define("tmds/symbols/CompositePointSymbol", [
	"jquery",
	"tmds/utils/__baseSymbolUtils",
	"./Symbol",
	"../validator"
], function($, baseSymbolUtils, Symbol, validator) {
	"use strict";
	
	function _fromJson(symJson) {
		var symbol = null;
		
		if (! validator.isDataObject(symJson) || ! validator.isString(symJson.type)) {			
			throw new Error('Invalid Symbol Object - ' + symJson + ' passed');
		}

		if (symJson) {
			switch (symJson.type) {
				case "FieldSymbol":
					symbol = new FieldSymbol(symJson);
					break;
				case "SimplePointSymbol":
					symbol = new SimplePointSymbol(symJson);
					break;
				case "SimpleLineSymbol":
					symbol = new SimpleLineSymbol(symJson);
					break;
				case "SimpleFillSymbol":
					symbol = new SimpleFillSymbol(symJson);
					break;
				case "TextSymbol":
					symbol = new TextSymbol(symJson);
					break;
				default:
					break;
			}
		}
		
		return symbol;
	}
	
	/**
	 * construct a composite point symbol
	 * @param options {Object} a JSON object with the following structure
	 * 	{ symbols: [sym1, sym2, ...] }
	 * @note 
	 * 	1. all options members are optional
	 * 	2. the symbol can be type of SimplePointSymbol, SimpleLineSymbol and TextSymbol.
	 * 	3. each symbol should be in its JSON representation.
	 */
	var CompositePointSymbol = function(options) {
		Symbol.call(this, options);
		
		// default composite point symbol
		this.symbols = [];
		
		var me = this;
		
		if (options != undefined && options.symbols != undefined) {
			
			if (Array.isArray(options.symbols)) {
				
				$.each(options.symbols, function(i, sym) {
					var newSym = baseSymbolUtils.fromJson(sym);
					addSymbol.call(me, newSym);
				});
			}
			else {
				throw new Error('Given value is not an instance of Symbol.');
			}
		}
	};
	
	/**
	 * add a symbol to the symbol list
	 * @param symbol {tmds.symbols.Symbol} a new symbol to be added
	 */
	function addSymbol(symbol) {
		
		if(! validator.isInstanceOf(symbol, Symbol)) {
			
			throw new Error('Given value is not an instance of Symbol.');
		}
		
		this.symbols.push(symbol);
		return this;
	}
	
	/**
	 * convert CompositePointSymbol object to JSON representation
	 */
	function toJson() {
		var symbols = [];
		$.each(this.symbols, function(i, sym) {
			symbols.push(sym.toJson());
		});
		
		return {
			type: this.type,
			symbols: symbols
		};
	}
	
	// CompositePointSymbol inherits Symbol with some extensions
	CompositePointSymbol.prototype = $.extend(Object.create(Symbol.prototype), {
		
		declaredClass: "tmds.symbols.CompositePointSymbol",
		type: "CompositePointSymbol",
		'addSymbol' : addSymbol,
		'toJson' : toJson
	});
	
	return CompositePointSymbol;	
});